/* eslint-disable */

import CryptoJS from 'crypto-js';
import httpServer from '../request/config/http';
import domain from '../request/config/config';
import jsBridge from './js-bridge';

const wx = require('weixin-js-sdk');

const Config = {
  domain: {
    online_host: 'h5.ileci.com',
    ecs_host: 'ecsh5.ileci.com',
    dev_host: 'devh5.ilce.com',
  },
  commonApi: {
    // 登录接口
    getImageCodeUrl: '/imgcode/getcode', // 获取图形验证码
    getCodeUrl: '/loginCommon/code/getCode', // 获得短信验证码接口
    getLoginUrl: '/loginCommon/phoneRegister', // 获取登录接口URL
    // 第三方登录接口
    getQQLoginUrl: '/api/qq/userLogin', // 第三方QQ登录接口
    getWeiboLoginUrl: '/api/weibo/userLogin', // 第三方微博登录接口
    getWeiXinLoginUrl: '/api/weixin/userLogin', // 第三方微信登录接口
    // 微信相关接口
    getWeiXinShareConfig: '/api/weixin/shareConfig', // 获取微信分享token接口
  },
  // 资源路径
  commonResource: {
    shareImg: '/logo/leci_logo_square_120.png', // 微信分享Logo
    appDownLoadUrl: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.xdf.recite', // 下载APP地址
  },
  shareData: {}, // 分享数据信息
};

// 处理url相关方法
const UrlDealFun = {
  /**
   * 获取URL参数
   * @param {[string]} paramsName [需要获取的参数名称，若不传则返回所有参数]
   */
  getUrlParameter: function(paramsName) {
    let params = '';
    if (paramsName && typeof paramsName === 'string') {
      // 获取指定参数
      const reg = new RegExp(`(^|&)${paramsName}=([^&]*)(&|$)`);
      params = window.location.search.substring(1).match(reg);
      return params != null ? decodeURI(params[2]) : '';
    } else {
      const paramObj = {};
      params = window.location.search.substring(1).split('&');
      Object.keys(params).forEach(key => {
        const obj = params[key].split('=');
        paramObj[obj[0]] = obj[1] ? decodeURI(obj[1]) : null;
      });
      return paramObj;
    }
  },
  /**
   * 删除页面链接地址中的指定参数
   * @param {[Array]}  value  存储的值
   */
  removeUrlParameter: function(paramObj) {
    let url = window.location.href;
    if (url.indexOf('?') >= 0) {
      const urlParam = url.split('?')[1].split('&');
      for (let i = 0; i < paramObj.length; i += 1) {
        for (let j = 0; j < urlParam.length; j += 1) {
          if (urlParam[j].split('=')[0] === paramObj[i]) {
            urlParam.splice(j, 1);
          }
        }
      }
      url =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        (urlParam.length > 0 ? '?' + urlParam.join('&') : '');
    }
    return url;
  },
  /**
   * 获取接口/资源全路径
   * @param {[string]}  value  相对路径
   * @param {[string]}  type   路径类型 resource
   */
  getCompletePath: function(path, type) {
    const { protocol } = window.location;
    let url = '';
    if (type && type === 'resource') {
      url = protocol + domain + '/web/activity-h5' + path;
    } else {
      url = protocol + domain + path;
    }
    return url;
  },
};

// 本地缓存相关方法
const LocalDataFun = {
  /**
   * 获取本地存储数据的方法
   * @param {[string]}  dataName  存储数据的键值
   * @param {[string]}  saveType 存储类型：local  表示LocalStorage存储（默认）; session  表示SessionStorage存储
   */
  getLocalData: function(dataName, saveType = 'local') {
    if (dataName) {
      if (saveType === 'session') {
        // 当前是获取的SessionStorage数据
        return JSON.parse(sessionStorage.getItem(dataName));
      } else {
        // 当前是获取的LocalStorage数据
        return JSON.parse(localStorage.getItem(dataName));
      }
    }
    return null;
  },
  /**
   * 保存/修改本地存储数据的方法
   * @param {[string]}  dataName  存储数据的键值
   * @param {[object]}  dataVal  存储数据的数据
   * @param {[string]}  saveType 存储类型：local  表示LocalStorage存储（默认）; session  表示SessionStorage存储
   */
  setLocalData: function(dataName, dataObj, saveType = 'local') {
    if (dataName && dataObj) {
      let storageData = this.getLocalData(dataName, saveType);
      if (!storageData) {
        storageData = {};
      }
      Object.keys(dataObj).forEach(key => {
        storageData[key] = dataObj[key];
      });
      if (saveType === 'session') {
        // 当前是 SessionStorage 存储
        sessionStorage.setItem(dataName, JSON.stringify(storageData));
      } else {
        // 当前是 LocalStorage 存储
        localStorage.setItem(dataName, JSON.stringify(storageData));
      }
    }
  },
  /**
   * 删除本地存储数据的方法
   * @param {[string]}  dataName  存储数据的键值
   * @param {[string]}  saveType 存储类型：local  表示LocalStorage存储（默认）; session  表示SessionStorage存储
   */
  removeLocalData: function(dataName, saveType = 'local') {
    if (dataName) {
      if (saveType === 'session') {
        sessionStorage.removeItem(dataName);
      } else {
        localStorage.removeItem(dataName);
      }
    }
  },
  /**
   * 删除本地存储相关键值的方法
   * @param {[string]}  dataName  存储数据的键值
   * @param {[array]}   removeList  需要删除的Key列表
   * @param {[string]}  saveType 存储类型：local  表示LocalStorage存储（默认）; session  表示SessionStorage存储
   */
  removeLocalKeyValue: function(dataName, removeList, saveType = 'local') {
    if (dataName && removeList) {
      const storageData = this.getLocalData(dataName, saveType);
      if (storageData) {
        const obj = {};
        if (typeof removeList === 'string' && removeList in storageData) {
          for (const i in storageData) {
            if (removeList !== i) {
              obj[i] = storageData[i];
            }
          }
          if (saveType === 'session') {
            // 当前是 SessionStorage 存储
            sessionStorage.setItem(dataName, JSON.stringify(obj));
          } else {
            // 当前是 LocalStorage 存储
            localStorage.setItem(dataName, JSON.stringify(obj));
          }
        } else if (removeList instanceof Array) {
          // eslint-disable-next-line
          for (const i in storageData) {
            let isTrue = false;
            for (let j = 0; j < removeList.length; j += 1) {
              if (i === removeList[j]) {
                isTrue = true;
                break;
              }
            }
            if (!isTrue) {
              obj[i] = storageData[i];
            }
          }
          if (saveType === 'session') {
            // 当前是 SessionStorage 存储
            sessionStorage.setItem(dataName, JSON.stringify(obj));
          } else {
            // 当前是 LocalStorage 存储
            localStorage.setItem(dataName, JSON.stringify(obj));
          }
        }
      }
    }
  },
};

// 浏览器相关方法
const BrowserFun = {
  versions: (function() {
    const ua = navigator.userAgent;
    return {
      trident: ua.indexOf('Trident') > -1, // IE浏览器
      presto: ua.indexOf('Presto') > -1, // opera浏览器
      webKit: ua.indexOf('AppleWebKit') > -1, // 谷歌/苹果浏览器
      gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1, // 火狐浏览器
      mobile: !!ua.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: ua.indexOf('iPhone') > -1, // iPhone/QQHD浏览器
      iPad: ua.indexOf('iPad') > -1, // iPad端
      webApp: ua.indexOf('Safari') === -1, // web应用程序，没有头部与底部
      qq: ua.toLowerCase().indexOf('qq') > -1, // 是否在QQ内或QQ浏览器打开
      weixin: ua.toLowerCase().indexOf('micromessenger') > -1, // 微信内打开
      weibo: ua.toLowerCase().indexOf('weibo') > -1, // 微博内打开
    };
  })(),
};

// APP相关方法
const AppBridgeFun = {
  /**
   * 验证当前是否在APP端内
   */
  isApp: function() {
    if (
      navigator.userAgent.indexOf('ileci') > -1 ||
      UrlDealFun.getUrlParameter('app')
    ) {
      return true;
    }
    return false;
  },
  /**
   * 版本号比较
   * 参数：
   * @param {[string]} version1 比较版本 1
   * @param {[string]} version2 比较版本 2
   * return 比较结果 0 版本相同; 1 版本1高于版本2; -1 版本1低于版本2; -2 没有获取到任何值
   */
  getCompareVersion: function(version1 = '', version2 = '') {
    let num = 0;
    if (version1 && version2) {
      // 两个版本都有值
      const version1Arr = version1.split('.');
      const version2Arr = version2.split('.');
      // 开始比较
      const length = Math.min(version1Arr.length, version2Arr.length);
      let istrue = false;
      for (let i = 0; i < length; i += 1) {
        if (version1Arr[i] !== version2Arr[i]) {
          num = version1Arr[i] > version2Arr[i] ? 1 : -1;
          istrue = true;
          break;
        }
      }
      // 如果当前验证位置都一致，则根据位数验证版本高低
      if (num === 0 && !istrue && version1Arr.length !== version2Arr.length) {
        num = version1Arr.length > version2Arr.length ? 1 : -1;
      }
    } else if (!version1 && version2) {
      // 当前没有获取到版本1 但是有版本2
      num = -1;
    } else if (!version2 && version1) {
      // 当前没有获取到版本2 但是有版本1
      num = 1;
    } else if (!version1 && !version2) {
      // 当前没有获取到任何值
      num = -2;
    }
    return num;
  },
  // 设置app分享
  appshare: function() {
    const { shareData } = Config;
    if (BrowserFun.versions.android) {
      /**
       * 控制按钮是否可以分享方法
       * window.phone_share_js_interface.canShare(flag, title, content, url)
       * @param flag    true: 可以分享  false: 不可以分享
       * @param title   分享的标题
       * @param content 分享的内容
       * @param url     分享的url
       */
      window.phone_share_js_interface.canShare(
        true,
        shareData.title,
        shareData.slogan,
        shareData.link
      );
    } else if (BrowserFun.versions.ios) {
      /**
       * 分享按钮是否显示
       * document.location = 'ios_share_show::url::text:title'
       * @param url   分享链接地址,以URL是否存在判断分享按钮是否显示
       * @param text  分享的文案
       */
      document.location =
        'ios_share_show::' +
        shareData.link +
        '::' +
        shareData.slogan +
        '::' +
        shareData.title;
    }
  },
  //  呼出app分享功能
  callAppShare: function() {
    const { shareData } = Config;
    if (BrowserFun.versions.android) {
      // 当前是 Android
      /**
       *
       * window.phone_share_js_interface.canShare(title, content, url)
       * @param title   分享的标题
       * @param content 分享的内容
       * @param url     分享的url
       */
      window.phone_share_js_interface.share(
        shareData.title,
        shareData.slogan,
        shareData.link
      );
    } else if (BrowserFun.versions.ios) {
      // 当前是 IOS
      /**
         * 分享按钮是否显示
         document.location = 'ios_h5_share::title::content::url'
         * @param title   分享的标题
         * @param content 分享的内容
         * @param url     分享的url
         */
      document.location =
        'ios_h5_share::' +
        shareData.title +
        '::' +
        shareData.slogan +
        '::' +
        shareData.link;
    }
  },
  ...jsBridge,
};

// 工具函数集合
const UtilsListFun = {
  /**
   * 浮点数减法
   */
  subtract: function(arg1, arg2) {
    let r1;
    let r2;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    const m = 10 ** Math.max(r1, r2);
    // 动态控制精度长度
    const n = r1 >= r2 ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  // 应用市场下载
  downloadAppByChannel: function() {
    let url = '';
    const UA = window.navigator.userAgent.toLocaleLowerCase();
    if (/huawei | honor/.test(UA)) {
      // 华为
      url =
        'https://appgallery.huawei.com/#/app/C10231520?locale=zh_CN&source=appshare&subsource=C10231520&shareTo=weixin&shareFrom=appmarket';
    } else if (/vivo/.test(UA)) {
      // VIVO
      url =
        'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=51829&resource=301&source=7';
    } else if (/mi | redmi/.test(UA)) {
      // 小米
      url = 'http://app.xiaomi.com/detail/61112';
    } else {
      // 应用宝
      url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.xdf.recite';
    }
    window.location.href = url;
  },
  // 应用市场url
  downloadUrlByChannel: function() {
    let url = '';
    const UA = window.navigator.userAgent.toLocaleLowerCase();
    if (/huawei | honor/.test(UA)) {
      // 华为
      url =
        'https://appgallery.huawei.com/#/app/C10231520?locale=zh_CN&source=appshare&subsource=C10231520&shareTo=weixin&shareFrom=appmarket';
    } else if (/vivo/.test(UA)) {
      // VIVO
      url =
        'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=51829&resource=301&source=7';
    } else if (/mi | redmi/.test(UA)) {
      // 小米
      url = 'http://app.xiaomi.com/detail/61112';
    } else {
      // 应用宝
      url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.xdf.recite';
    }
    return url;
  },
  // 获取当前环境
  getCurrentEnv: function() {
    if (window.location.host == Config.domain.online_host) {
      return 'online';
    } else if (window.location.host == Config.domain.ecs_host) {
      return 'ecs';
    } else {
      return 'dev';
    }
  },
  // 加密方法
  encrypt(word, keyStr = 'aUiLeVh5UNDrMiWi') {
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
  // 解密方法
  decrypt: function(word, keyStr = 'aUiLeVh5UNDrMiWi') {
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
};

// 第三方API方法
const ThirdApisFun = {
  /**
   * 第三方登录
   * @param {[object]}  loginType  第三方登录方式: weixin 微信登录; weibo 微博登录; qq QQ登录
   */
  otherLogin: function(loginType) {
    let redirectUrl = '';
    if (loginType === 'weibo') {
      redirectUrl =
        'https://api.weibo.com/oauth2/authorize?client_id=' +
        this.getServiceAppId('weibo') +
        '&response_type=code&redirect_uri=' +
        encodeURIComponent(UrlDealFun.removeUrlParameter(['code', 'state'])) +
        '&state=' +
        loginType;
    } else if (loginType === 'weixin') {
      redirectUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        this.getServiceAppId('weixin') +
        '&redirect_uri=' +
        encodeURIComponent(UrlDealFun.removeUrlParameter(['code', 'state'])) +
        '&response_type=code&scope=snsapi_userinfo&state=' +
        loginType +
        '#wechat_redirect';
    } else if (loginType === 'qq') {
      redirectUrl =
        'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=' +
        this.getServiceAppId('qq') +
        '&redirect_uri=' +
        encodeURIComponent(UrlDealFun.removeUrlParameter(['code', 'state'])) +
        '&state=' +
        loginType +
        '&scope=get_user_info';
    }
    window.location.replace(redirectUrl);
  },
  /**
   * 获取APPID
   * @param {[object]}  type  [第三方] weixin:微信 weibo:微博 qq:QQ
   */
  getServiceAppId: function(type = 'weixin') {
    if (type === 'weixin') {
      // 获取微信AppId
      let wxAppId = '';
      if (window.location.host === Config.domain.online_host) {
        // 线上环境
        wxAppId = 'wx0838b45ca17aa17d';
      } else {
        // ecs测试环境
        wxAppId = 'wxd4d88c56abf0a354';
      }
      return wxAppId;
    } else if (type === 'weibo') {
      // 获取微博AppId
      let appKey = '';
      if (window.location.host === Config.domain.online_host) {
        // 线上环境
        appKey = '4243246361';
      } else {
        // ecs测试环境
        appKey = '2508196434';
      }
      return appKey;
    } else if (type === 'qq') {
      // 获取QQ AppId
      let qqAppId = '';
      if (window.location.host === Config.domain.online_host) {
        // 线上环境
        qqAppId = '101457664';
      } else {
        // ecs测试环境
        // qqAppId = '101454766';
        qqAppId = '101962662';
      }
      return qqAppId;
    } else {
      return '';
    }
  },
  /**
   * QQ分享
   */
  qqShare: function(callback) {
    const { shareData } = Config;
    if (mqq) {
      const qqShareData = {
        title: shareData.title ? shareData.title : '',
        desc: shareData.slogan ? shareData.slogan : '',
        image_url: shareData.imgUrl,
        share_url: shareData.link ? shareData.link : '', // 分享链接长度不能超过120个字节
      };
      mqq.data.setShareInfo(qqShareData, callback);
    }
  },
  /**
   * 微信相关设置
   */
  weixin: {
    isShare: false, // 是否允许分享
    shareType: 'all', // 当前分享状态
    callbackFun: null, // 回调函数
    // 获取微信权限的方法
    GetWechatAuthorityFun: function() {
      // 设置公共API接口使用权限
      const wechatApi = [
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'onVoicePlayEnd',
        'uploadVoice',
        'downloadVoice',
      ];
      if (this.shareType === 'service') {
        // 只能在服务号内接口
        // wechatApi = wechatApi.concat([])
      } else {
        // 可以分享到所有端
        // wechatApi = wechatApi.concat([]);
      }
      return wechatApi;
    },
    // 获取微信菜单权限的方法
    GetMenuItemsFun: function() {
      let menuApi = [
        'menuItem:refresh',
        'menuItem:setFont',
        'menuItem:profile',
        'menuItem:addContact',
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
      ];
      if (this.shareType === 'service') {
        // 设置服务号中的菜单显示权限
        // menuApi = menuApi.concat([])
      } else {
        menuApi = menuApi.concat([
          'menuItem:share:qq',
          'menuItem:share:weiboApp',
          'menuItem:favorite',
          'menuItem:copyUrl',
          'menuItem:openWithSafari',
        ]);
      }
      return menuApi;
    },
    // 微信初始化完成的执行方法
    ConfigComplateFun: function() {
      // 隐藏所有非基础按钮接口
      wx.hideAllNonBaseMenuItem();
      if (this.isShare) {
        // 微信初始化设置完成，可以修改分享信息
        // 允许显示的微信菜单项
        const menuList = this.GetMenuItemsFun();
        wx.showMenuItems({
          menuList: menuList,
        });
        // 微信分享
        this.wxShare();
      }
      // 执行回调函数
      const callback = this.callbackFun;
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    // 微信初始化请求回调函数
    ConfigCallBackFun: function(resp) {
      if (resp.code === 0 && resp.data) {
        // 获取分享权限
        const apiList = this.GetWechatAuthorityFun();
        const wxData = resp.data;
        wx.config({
          debug: false, // 是否开启调试模式
          appId: wxData.appId, // 公众号ID
          timestamp: wxData.timestamp, // 生成签名的时间戳
          nonceStr: wxData.nonceStr, // 生成签名的随机串
          signature: wxData.signature, // 签名
          jsApiList: apiList, // 允许使用的API接口
        });
        wx.ready(() => {
          console.log('--- weixin config ready:');
          this.ConfigComplateFun();
        });
        wx.error(error => {
          console.log('--- weixin config Error:', error);
        });
      }
    },
    // 设置微信分享的方法
    wxShare: function() {
      const { shareData } = Config;
      if (shareData.title) {
        // 获取微信版本号
        const wechatV = navigator.userAgent.match(
          /MicroMessenger\/([\d.]+)/i
        )[1];
        // 当版本低于 6.7.3 版本时，使用老分享接口，否则使用新分享接口
        if (
          wechatV &&
          BrowserFun.versions.ios &&
          AppBridgeFun.getCompareVersion(wechatV, '6.7.3') >= 0
        ) {
          // 分享给微信朋友 及 QQ
          wx.updateAppMessageShareData(
            {
              title: shareData.title, // 分享标题
              desc: shareData.slogan, // 分享描述
              link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareData.imgUrl, // 分享图标
            },
            res => {
              console.log('--- 分享给微信朋友 及 QQ 成功: ', res);
            }
          );
          // 分享到微信朋友圈 及 QQ空间
          wx.updateTimelineShareData(
            {
              title: shareData.title, // 分享标题
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl, // 分享图标
            },
            res => {
              console.log('--- 分享到微信朋友圈 及 QQ空间 成功: ', res);
            }
          );
        } else {
          // 分享微信朋友圈
          wx.onMenuShareTimeline({
            title: shareData.title, // 分享标题
            link: shareData.link, // 分享链接
            imgUrl: shareData.imgUrl, // 分享图标
            success: function() {
              console.log('--- 分享到微信朋友圈成功 ---');
            },
          });
          // 分享微信好友
          wx.onMenuShareAppMessage({
            title: shareData.title, // 分享标题
            desc: shareData.slogan, // 分享描述
            link: shareData.link, // 分享链接
            imgUrl: shareData.imgUrl, // 分享图标
            type: 'link',
            success: function() {
              console.log('--- 分享微信好友成功 ---');
            },
          });
          if (ThirdApisFun.weixin.shareType === 'service') {
            // 分享到QQ
            wx.onMenuShareQQ({
              title: shareData.title, // 分享标题
              desc: shareData.slogan, // 分享描述
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl, // 分享图标
              success: function() {
                console.log('--- 分享到QQ成功 ---');
              },
              cancel: function() {
                console.log('--- 用户取消分享到QQ了 ---');
              },
            });
          }
        }
      }
    },
    // 获取网络类型
    getNetworkType: function(callback) {
      wx.getNetworkType({
        success: function(res) {
          if (callback && typeof callback === 'function') {
            callback(res.networkType);
          }
        },
      });
    },
    // 微信授权
    wxAuthorize: function() {
      const state = new Date().getTime();
      const redirectUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        ThirdApisFun.getServiceAppId('weixin') +
        '&redirect_uri=' +
        encodeURIComponent(UrlDealFun.removeUrlParameter(['code', 'state'])) +
        '&response_type=code&scope=snsapi_userinfo&state=' +
        state +
        '#wechat_redirect';
      window.location.href = redirectUrl;
    },
    /**
     * 微信初始化
     * @param  {object}  shareObj  [微信权限设置]
     * shareObj = {
     *  isShare: true,    // 是否允许分享
     *  url: '',          // 访问接口地址
     *  shareType: '',    // 是否分享权限: service 只分享微信内部，all 支持全部分享(默认)
     *  callbackFun: null // 回调函数
     * }
     */
    wxConfig: function(shareObj) {
      // 如果当前不是在微信内则终止执行
      if (BrowserFun.versions.weixin) {
        // 获取允许分享权限
        this.isShare =
          shareObj && shareObj.isShare !== undefined ? shareObj.isShare : true;
        // 获取分享类型
        this.shareType =
          shareObj && shareObj.shareType !== undefined
            ? shareObj.shareType
            : 'all';
        // 获取回调函数
        this.callbackFun =
          shareObj && shareObj.callbackFun !== undefined
            ? shareObj.callbackFun
            : null;
        // 获取接口地址
        const url =
          shareObj && shareObj.url !== undefined
            ? shareObj.url
            : Config.commonApi.getWeiXinShareConfig;
        // 获取微信数据时的服务号类型 (空为乐词服务号，WeixinWebCamp=阅读营，WeixinWebFP=外刊阅读， WeixinWebLocal=本地开发参数)
        const shareMode =
          shareObj && shareObj.shareMode !== undefined
            ? shareObj.shareMode
            : '';
        // 请求微信初始化接口
        const params = {
          url: window.location.href,
          shareType: shareMode,
        };
        httpServer
          .post(url, { params })
          .then(res => {
            this.ConfigCallBackFun(res);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
  },
};

// 设置ticket到localstorage
const setLocalTokenData = function(data, type) {
  var tokenData = {}
  if (type === 'phone') {
    tokenData = {
      token: data.ticket.ticket || null,
      uid: data.user.uid
    }
  } else {
    tokenData = {
      token: data.userTicketModel.ticket || null,
      uid: data.uid
    }
  }
  
  localStorage.setItem('leci-token', JSON.stringify(tokenData));
}

export default {
  Config,
  UrlDealFun,
  LocalDataFun,
  BrowserFun,
  AppBridgeFun,
  UtilsListFun,
  ThirdApisFun,
  setLocalTokenData
};
